var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28.002,
    viewBox: "0 0 28 28.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "history",
    transform: "translate(-15.52 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907",
    transform: "translate(15.52 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5241",
    "data-name": "Path 5241",
    d: "M29.144,22.143a7.642,7.642,0,0,1,4.3-6.761,8.718,8.718,0,0,1,8.4.294c.009-.57.013-1.179.013-1.836a64.857,64.857,0,0,0-.365-7.668h.034A6.621,6.621,0,0,0,36.983.711c-.065-.023-.13-.045-.2-.066a7.393,7.393,0,0,0-1.5-.3l-.049,0A42.087,42.087,0,0,0,28.9,0a47.487,47.487,0,0,0-6.7.339l-.049,0a7.376,7.376,0,0,0-1.567.328V.647a6.64,6.64,0,0,0-4.7,5.512,64.9,64.9,0,0,0-.367,7.681,64.894,64.894,0,0,0,.367,7.681,6.778,6.778,0,0,0,6.23,5.828l.049,0a41.576,41.576,0,0,0,6.346.339c1.356,0,2.338-.016,3.109-.045a7.441,7.441,0,0,1-2.477-5.505ZM22.3,7.282H35.066a1.35,1.35,0,0,1,1.392,1.3,1.35,1.35,0,0,1-1.392,1.3H22.307a1.35,1.35,0,0,1-1.392-1.3,1.35,1.35,0,0,1,1.392-1.3Zm0,8.18a1.306,1.306,0,1,1,0-2.606h7.278a1.306,1.306,0,1,1,0,2.606Z",
    transform: "translate(-15.52 0)",
    fill: "#90348a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5242",
    "data-name": "Path 5242",
    d: "M288.079,297.74a5.859,5.859,0,1,0,5.859,5.859,5.859,5.859,0,0,0-5.859-5.859Zm2.322,6.717h-2.439a.7.7,0,0,1-.7-.7v-3.746a.7.7,0,0,1,1.395,0v3.049H290.4a.7.7,0,1,1,0,1.395Z",
    transform: "translate(-265.938 -281.456)",
    fill: "#90348a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareHistory);
export default __webpack_public_path__ + "static/media/share-history.3626ef59d3fa61901db94626a9ec117a.svg";
export { ForwardRef as ReactComponent };